export default {
  facebookUrl: 'https://www.facebook.com/UFC',
  twitterUrl: 'https://twitter.com/ufc',
  buyUrl: 'https://plus.espn.com/',
  shareUrl: 'https://ufc.com/connect',
  terms: 'By checking this box, you agree that you would like to receive offers and information from UFC (Zuffa,LLC) about similar events and products as described in our <a href="http://www.ufc.com/privacy-policy" target="_blank" style="text-decoration: underline">Privacy Policy</a>. You can opt-out at any time.',
  instructionsMobile: [
    {
      instructionNumber: '01',
      textPrimary: 'Match your<br>opponent’s emotions',
      textSecondary: 'If they get angry. You get angry.'
    },
    {
      instructionNumber: '02',
      textPrimary: 'Timing is everything',
      textSecondary: 'Act fast to match the emotion.'
    },
    {
      instructionNumber: '03',
      textPrimary: 'Raise<br>your phone',
      textSecondary: 'Good lighting can improve your game.'
    },
    {
      instructionNumber: '04',
      textPrimary: 'Turn up the volume',
      textSecondary: 'Get the full staredown experience.'
    },
    {
      instructionNumber: '05',
      textPrimary: 'Get your<br>game face on',
      textSecondary: 'Prepare to face your opponent.'
    }
  ],
  instructionsDesktop: [
    {
      instructionNumber: '01',
      textPrimary: 'Match your<br>opponent’s emotions',
      textSecondary: 'If they get angry. You get angry.'
    },
    {
      instructionNumber: '02',
      textPrimary: 'Timing is everything',
      textSecondary: 'Act fast to match the emotion.'
    },
    {
      instructionNumber: '03',
      textPrimary: 'Turn up the volume',
      textSecondary: 'Get the full staredown experience.'
    },
    {
      instructionNumber: '04',
      textPrimary: 'Get your<br>game face on',
      textSecondary: 'Prepare to face your opponent.'
    }
  ]
}
